import React from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useLocation } from 'react-router-dom';
import ArchivesFacturation from './ArchivesFacturation';
import { getFacturationSectionArchiveByRoute } from './config/facturationSectionArchivesConfig';

const FacturationSectionArchivesPage = () => {
  const { t } = useTranslation();
  const p = (key, opts) => t(`modules.facturation.pages.facturationSectionArchivesPage.${key}`, opts);
  const { pathname } = useLocation();
  const sectionConfig = getFacturationSectionArchiveByRoute(pathname);

  if (!sectionConfig) {
    return <Navigate to="/archives" replace />;
  }

  return (
    <div aria-label={p('title')}>
      <span className="sr-only">{p('subtitle')}</span>
      <ArchivesFacturation sectionConfig={sectionConfig} />
    </div>
  );
};

export default FacturationSectionArchivesPage;
